// extracted by mini-css-extract-plugin
module.exports = {"container":"no-products_container__3Pb9L","header":"no-products_header__3swKe","icon":"no-products_icon__dieJi"};